import React from "react";
import PropTypes from "prop-types";
import Carousel from "react-material-ui-carousel";
import { useTranslation } from "react-i18next";

import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

const WhiteTextTypography = withStyles({
  root: {
    color: "#fff",
    fontWeight: 600,
  },
})(Typography);

const useStyles = makeStyles((theme) => ({
  customTypo: {
    textAlign: "center",
    [theme.breakpoints.up("md")]: { fontSize: 36 },
    [theme.breakpoints.down('md')]: { fontSize: 24 },
  },
}));

function AccountCarousel() {
  const classes = useStyles();
  const { t } = useTranslation();

  const items = [
    {
      name: t("carousel.name1"),
      description: t("carousel.description1"),
      imagePath: "./src/_images/calendar_fff.png",
    },
    {
      name: t("carousel.name2"),
      description: t("carousel.description2"),
      imagePath: "./src/_images/pay_fff.png",
    },
    {
      name: t("carousel.name3"),
      description: t("carousel.description3"),
      imagePath: "./src/_images/resources_fff.png",
    },
  ];

  return (
    <Carousel>
      {items.map((carouselItem, i) => (
        <Grid
          key={i}
          container
          direction="column"
          alignItems="center"
          justifyContent="space-evenly"
          style={{ height: "calc(100vh - 50px)", minHeight: 475, padding: 15 }}
        >
          <Grid item>
            <img
              src={carouselItem.imagePath}
              alt={carouselItem.name}
              width="100%"
            />
          </Grid>
          <Grid item>
            <WhiteTextTypography className={classes.customTypo}>
              {carouselItem.name}
            </WhiteTextTypography>
          </Grid>
          <Grid item style={{ textAlign: "center" }}>
            <WhiteTextTypography variant="h6">
              {carouselItem.description}
            </WhiteTextTypography>
          </Grid>
        </Grid>
      ))}
    </Carousel>
  );
}

AccountCarousel.propTypes = {
  carouselItem: PropTypes.object,
};

export { AccountCarousel };
